import request from '@/utils/request';


let server = {
  captcha: '/captcha', // 图形验证
};


//  图形验证
export function getCaptcha(params) {
  return request({
    url: server.captcha,
    method: 'post',
    data:params
  })
}







// WEBPACK FOOTER //
// ./src/api/getCode.js